// extracted by mini-css-extract-plugin
export default {"container":"item-image-items_container__ZyBUQ","image":"item-image-items_image__kTtD4","itemContainer":"item-image-items_itemContainer__DWdXi"};